// extracted by mini-css-extract-plugin
export default {"row":"TCkvv__row","personalInfo":"obLpy__personalInfo","name":"L22ku__name","email":"sq7gf__email","removed":"hYi2N__removed","imgComp":"RKBJQ__imgComp"};